import React, { Component, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import "./pdf.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PhOneFormPdf from "./PhOneFormPdf";

const Ph1Form = ({ currentProperty }) => {
  useEffect(() => {
    if (currentProperty != null) {
      const input = document.getElementById("Artboard__1");
      html2canvas(input).then((canvas) => {
        var imgWidth = 200;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        var position = 0;
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        pdf.save("ph1.pdf");
        window.open(pdf.output("bloburl"), "_blank");
      });
    }
  }, [currentProperty]);
  const history = useHistory();

  if (currentProperty != null) {
    return (
      <React.Fragment>
        {currentProperty?.data && (
          <div id="Artboard__1">
            <PhOneFormPdf data={currentProperty?.data?.data} />
          </div>
        )}
        <div className="close-button-section">
          <Button
            className="close-button"
            // type="primary"
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowLeftOutlined />
            <span>Back</span>
          </Button>
        </div>
      </React.Fragment>
    );
  } else {
    return <div></div>;
  }
};

const mapStateToProps = ({ property: { currentProperty } }) => ({
  currentProperty,
});

const mapDispatchToProps = (dispatch) => ({});

Ph1Form.propTypes = {
  currentProperty: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Ph1Form);
